<section
  class="business__card"
  [ngClass]="{ 'business__card--borderless': !border }"
>
  <div class="business__card__img">
    @if (contactInfo.image) {
      <div
        [ngStyle]="{
          'background-image': 'url(' + contactInfo.image + ')',
        }"
      ></div>
    }

    @if (!contactInfo.image) {
      <div class="business__card__imgPlaceholder">
        <p class="t-data">No image available</p>
      </div>
    }
  </div>

  <div>
    <p class="t-bold t-data">{{ contactInfo.name }}</p>
    @if (contactInfo.title) {
      <p class="t-data">{{ contactInfo.title }}</p>
    }
    @if (contactInfo.phone) {
      <a class="t-data t-bold t-link" href="tel:{{ contactInfo.phone }}"
        >{{ contactInfo.phone }}
      </a>
    }
    @if (contactInfo.location) {
      <p class="t-data">{{ contactInfo.location.address1 }}</p>
      <p class="t-data">
        {{ contactInfo.location.city }},
        {{ contactInfo.location.state }}
        {{ contactInfo.location.zipcode }}
      </p>
    }
    @if (contactInfo.link) {
      <a
        href="{{ contactInfo.link }}"
        target="_blank"
        class="t-link t-bold t-data"
        innerHTML="Get Directions"
      ></a>
    }

    @if (contactInfo.other) {
      <p class="t-data">{{ contactInfo.other }}</p>
    }
  </div>
</section>
